import { LifeBuoy } from "lucide-react";

// Inline support link used across booking success, coach profile, etc.
export default function SupportLink({ compact = false, className = "" }) {
  const href = "mailto:support@coachly.demo?subject=Coachly%20support%20request";
  if (compact) {
    return (
      <a
        href={href}
        data-testid="support-link"
        className={`text-[12.5px] text-slate-500 hover:text-[#2563EB] transition-colors inline-flex items-center gap-1.5 ${className}`}
      >
        <LifeBuoy className="w-3.5 h-3.5" /> Need help?
      </a>
    );
  }
  return (
    <a
      href={href}
      data-testid="support-link"
      className={`inline-flex items-center gap-2 h-10 px-4 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-700 text-[13px] font-medium transition-colors ${className}`}
    >
      <LifeBuoy className="w-4 h-4" strokeWidth={2} />
      Contact support
    </a>
  );
}
